import { type EditorView } from 'prosemirror-view'
import { Slice, DOMSerializer } from 'prosemirror-model'

// NOTE: Copied from this prosemirror file https://github.com/ProseMirror/prosemirror-view/blob/dfa84353afc7603a250501cbaaf2a684f6d6c2be/src/clipboard.js#L3
// as it is apparently private API

// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const wrapMap = {
  thead: ['table'],
  tbody: ['table'],
  tfoot: ['table'],
  caption: ['table'],
  colgroup: ['table'],
  col: ['table', 'colgroup'],
  tr: ['table', 'tbody'],
  td: ['table', 'tbody', 'tr'],
  th: ['table', 'tbody', 'tr'],
}

let _detachedDoc: Document | null = null
export function detachedDoc() {
  return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument('title'))
}

export function serializeForClipboard(view: EditorView, slice: Slice, options?: { forceCloseSlice: boolean }) {
  let context = [],
    { content, openStart, openEnd } = slice
  while (openStart > 1 && openEnd > 1 && content.childCount === 1 && content.firstChild?.childCount === 1) {
    openStart--
    openEnd--
    let node = content.firstChild
    context.push(node.type.name, node.attrs !== node.type.spec.attrs ? node.attrs : null)
    content = node.content
  }

  let serializer = view.someProp('clipboardSerializer') || DOMSerializer.fromSchema(view.state.schema)
  let doc = detachedDoc(),
    wrap = doc.createElement('div')
  wrap.appendChild(serializer.serializeFragment(content, { document: doc }))

  let firstChild = wrap.firstChild,
    needsWrap
  while (
    firstChild &&
    firstChild.nodeType === 1 &&
    (needsWrap = wrapMap[firstChild.nodeName.toLowerCase() as keyof typeof wrapMap])
  ) {
    for (let i = needsWrap.length - 1; i >= 0; i--) {
      let wrapper = doc.createElement(needsWrap[i])
      while (wrap.firstChild) wrapper.appendChild(wrap.firstChild)
      wrap.appendChild(wrapper)
    }
    firstChild = wrap.firstChild
  }

  if (firstChild && firstChild.nodeType === 1) {
    if (options?.forceCloseSlice) {
      ;(firstChild as HTMLElement).setAttribute('data-pm-slice', `0 0 ${JSON.stringify(context)}`)
    } else {
      ;(firstChild as HTMLElement).setAttribute('data-pm-slice', `${openStart} ${openEnd} ${JSON.stringify(context)}`)
    }
  }

  let text =
    view.someProp('clipboardTextSerializer', (f) => f(slice)) ||
    slice.content.textBetween(0, slice.content.size, '\n\n')

  return { dom: wrap, text }
}
